<div
  class="right-drawer"
  [class.is-map]="!isWallDisplay"
  [class.is-dark]="userPref.isDarkTheme()"
  [class.is-open]="isOpen">
  @if (isOpen) {
    <ng-content></ng-content>
  }
</div>
